// phonics_data_lt05.js
// Letter Teams L05 - L5 Blends cl, pl, gl
// 路由：/phonics/lt05

const MEDIA_BASE = '/media/phonics/lt05';
const V = 'v1';

export const letterDataLt05 = {
  id: 'lt05',
  letter: 'L05',
  title: 'L5 Blends cl, pl, gl',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1)
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3)
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P4-P6: 三段故事（story-video-left-lines-right）
  storySections: [
    {
      label: 'Learn the story (1)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals see Glen.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "Glen is sad.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "I cannot find my clip.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "We will find it.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "The pals look here and there.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "It is not under the plate.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "It is not in the glass.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "It is not by the plug.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "We can ask Pink!", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "The pals see Pink.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "Please help us.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Glen cannot find his clip.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Oh I have your clip!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Glen is glad.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "I like your plane.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "My plane can fly!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "The pals clap.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
      ],
    },
  ],
};
